

import React from 'react';
import cx from 'classnames';

import Icon from '../../Icon';
import Text from '../../Text';
import ToolTip from '../../ToolTip';
import '../styles/_button.scss';

const TYPE_PROPS = {
  PRIMARY: { typeClass: 'button--primary', iconColour: 'white' },
  SECONDARY: { typeClass: 'button--secondary', iconColour: 'white' },
  TERTIARY: { typeClass: 'button--tertiary', iconColour: 'denim' },
  QUATERNARY: { typeClass: 'button--quaternary', iconColour: 'white' },
  QUINARY: { typeClass: 'button--quinary', iconColour: 'white' }
};






















function getButtonContent(children) {
  if (!children) {return null;}

  return typeof children === 'string' || typeof children === 'number' ?
  <Text button>{children}</Text> :
  children;
}

function getButtonSubtitle(subtitle) {
  if (!subtitle) {return null;}

  return <Text details>{subtitle}</Text>;
}

function getDecorator(element, color, size) {
  if (!element) {return null;}

  return (
    <div className="button__content__decorator">
      {
      typeof element === 'string' ?

      <Icon
        key="decorator-icon"
        className="button__content__decorator__icon"
        name={element}
        color={color}
        size={size || 15} /> :


      element}

    </div>);

}

function ButtonFactory(ButtonElement) {
  /**
   * Button React component. Takes the same props as a standard <button>button</button> element
   *
   * @param {ButtonProps} props
   *
   * @return {React.Element}
   */
  return function Button(props) {
    const {
      disabled = false,
      className = '',
      busy = false,
      children = null,
      type = 'PRIMARY',
      beta = false,
      prefix,
      prefixSize,
      suffix,
      hasMenuIcon,
      fromChipList,
      subtitle,
      tooltipId,
      tooltipLabel,
      tooltipPlace,
      tooltipClass,
      onClick,
      isFullWidth,
      ...btnProps
    } = props;
    if (!TYPE_PROPS[type]) {
      /* eslint-disable no-console */
      console.warn(`The button type (${type}) doesn't exist. Falling back to PRIMARY.`);
    }

    const buttonContent = getButtonContent(children);
    const buttonSubtitle = getButtonSubtitle(subtitle);
    const isIconButton = prefix && !buttonContent;
    const { typeClass, iconColour: typeIconColour } = isIconButton ?
    TYPE_PROPS.TERTIARY :
    TYPE_PROPS[type] || TYPE_PROPS.PRIMARY;
    const iconColour = disabled ? 'nevada' : typeIconColour;
    const prefixDecorator = getDecorator(prefix, iconColour, isIconButton ? 20 : prefixSize);
    const suffixDecorator = hasMenuIcon && getDecorator('arrowdown', iconColour, 8) ||
    fromChipList && getDecorator(suffix, iconColour, 16);

    return (
      <ToolTip id={tooltipId} label={tooltipLabel} place={tooltipPlace} className={tooltipClass}>
        <ButtonElement
          className={cx(
            'button',
            typeClass,
            {
              'button--disabled': disabled,
              'button--busy': busy,
              'button--beta': beta,
              'button--icon-only': isIconButton,
              'button--full-width': isFullWidth
            },
            className
          )}
          onClick={!disabled && !busy ? onClick : void 0}
          {...btnProps}>

          {
          busy ?

          <div className="button--busy__icon">
                  <Icon name="shootstagrad" color={disabled ? 'black' : typeIconColour} spin />
                </div> :

          null}

          <div className={cx(
            'button__content',
            {
              'button__content--column': subtitle
            }
          )}>

            {prefixDecorator}
            {buttonContent}
            {buttonSubtitle}
            {suffixDecorator}
          </div>
          {beta ? <div className="button--beta__text">BETA</div> : null}
        </ButtonElement>
      </ToolTip>);

  };
}

export default ButtonFactory;